function getAltAxis(axis) {
  return axis === 'x' ? 'y' : 'x';
}

export { getAltAxis as default };
